import React, {Component} from "react";
import CreatableSelect from 'react-select/creatable';
import {getCustomStyles, getSelectGroupBadgeStyles, getSelectGroupStyles} from "../../../../data/themes";
import {scrollIntoView} from "../../../util/util-vanilla";
import { classNames } from "../../../util/util-helpers";
import Tooltip from "../../tooltip";

export default class FieldCreatableAsync extends Component {

    state = {
        isLoading: false,
        currentOptions: [],
        defaultOptions: [],
        hintMessage: "",
    };

    debounceTimeout = null;
    hintTimeout = null;

    componentWillUnmount() {
        clearTimeout(this.debounceTimeout);
        clearTimeout(this.hintTimeout);
    }

    handleInputChange = (inputValue) => {
        if (!this.props.loadOptions) return;

        clearTimeout(this.debounceTimeout);
        clearTimeout(this.hintTimeout);
        this.setState({hintMessage: ""});

        const len = inputValue?.length ?? 0;

        if (len === 0) {
            this.setState({currentOptions: this.state.defaultOptions, isLoading: false});
            return;
        }

        if (len < 3) {
            this.setState({currentOptions: [], isLoading: false});
            this.hintTimeout = setTimeout(
                () => this.setState({hintMessage: "Type at least 3 characters to search"}),
                2000
            );
            return;
        }

        this.setState({isLoading: true});
        this.debounceTimeout = setTimeout(() => {
            this.props.loadOptions(inputValue, (options) => {
                this.setState({isLoading: false, currentOptions: options ?? []});
            });
        }, 500);
    };

    render() {
        const pairs = this.props.values ? this.props.values : {};

        const formatGroupLabel = data => (
            <div style={getSelectGroupStyles()}>
                <span>{data.label}</span>
                <span style={getSelectGroupBadgeStyles()}>{data.options.length}</span>
            </div>
        );

        const tooltipPlacement = this.props.menuPlacement === "top" ? "bottom-start" : "top-start";

        return (
            <React.Fragment>
                <Tooltip
                    content="Type at least 3 characters to search"
                    visible={!!this.state.hintMessage}
                    disabled={!this.state.hintMessage}
                    trigger="manual"
                    placement={tooltipPlacement}
                >
                <div>
                <CreatableSelect
                    ref={this.props.innerRef}
                    styles={this.props.inputStyles ?? getCustomStyles()}
                    className={
                        classNames(
                            "select-css-search p-0",
                            !!this.props.addClass ? this.props.addClass : undefined,
                            !!this.props.className ? this.props.className : undefined,
                            this.props.errorMessage ? "is-invalid" : undefined
                        )
                    }
                    isDisabled={!!this.props.disabled}
                    onChange={(selectedOption) => {
                        this.props.onChange(this.props.name, selectedOption);
                    }}
                    name={this.props.name}
                    value={!this.props.loadOptions ? (this.props.value ? {
                        value: this.props.value,
                        label: pairs[this.props.value]
                    } : null) : this.props.value}
                    options={this.props.loadOptions ? this.state.currentOptions : this.props.options}
                    filterOption={this.props.loadOptions ? () => true : undefined}
                    onCreateOption={this.props.onCreateOption ? (value) => this.props.onCreateOption(this.props.name, value) : null}
                    isClearable={!!this.props.isClearable}
                    isMulti={this.props.isMulti}
                    isLoading={this.state.isLoading}
                    loadingMessage={() => 'Searching...'}
                    placeholder={!!this.props.placeholder ? this.props.placeholder : 'Select...'}
                    formatGroupLabel={formatGroupLabel}
                    formatCreateLabel={!!this.props.formatCreateLabel ? this.props.formatCreateLabel : userInput => 'Create "' + userInput + '"'}
                    isValidNewOption={(inputValue) => inputValue?.length >= 3}
                    onFocus={(event) => {
                        if (this.props.onFocus) {
                            this.props.onFocus(event);
                        }

                        if (this.props.loadOptions && !this.state.defaultOptions?.length) {
                            this.setState({isLoading: true});
                            this.props.loadOptions('', (options) => {
                                if (options) {
                                    this.setState({isLoading: false, defaultOptions: options, currentOptions: options});
                                }
                            });
                        }

                        scrollIntoView(event);
                    }}
                    onBlur={(event) => {
                        this.setState({hintMessage: ""});
                        if (this.props.onBlur) {
                            this.props.onBlur(event);
                        }
                    }}
                    onInputChange={(value, {action}) => {
                        this.handleInputChange(value);
                        if (!!this.props.onInputChange) {
                            this.props.onInputChange(this.props.name, value);
                        }
                    }}
                    menuPortalTarget={this.props.hasPortal ? document.body : null}
                    defaultMenuIsOpen={this.props.defaultMenuIsOpen}
                    inputValue={this.props.inputValue}
                />
                </div>
                </Tooltip>

                {this.props.errorMessage && (
                    <div className={"text-red-600 font-semibold"} style={{gridColumn: "1/-1"}}>
                        {!!this.props.translate && (
                            this.props.errorMessage.reduce((memo, it) => {
                                if (it.key) {
                                    return this.props.translate(it.key, it.values) + (!!memo ? "," + memo : "")
                                }
                                return this.props.translate(it) + (!!memo ? "," + memo : "")
                            }, "")
                        )}
                        {!this.props.translate && (
                            <span>Field required*</span>
                        )}
                    </div>
                )}
            </React.Fragment>
        )
    }
}
